import React, { useMemo } from 'react'
import { Alert, Button, Modal, message } from 'antd'

const buildWarningMessage = truncationInfo => {
  if (!truncationInfo?.isTruncated) return null

  const additionalCount = truncationInfo.additionalCount
  if (typeof additionalCount === 'number' && additionalCount > 0) {
    return `We've shown the first 10 errors. There may be ${additionalCount} more error(s) - please check the rest of your file.`
  }

  return "We've shown the first 10 errors. There may be more - please check the rest of your file."
}

const ValidationErrorsModal = ({
  visible = false,
  errors = [],
  truncationInfo = null,
  onClose,
}) => {
  const errorCount = errors.length
  const warningMessage = useMemo(
    () => buildWarningMessage(truncationInfo),
    [truncationInfo],
  )

  const handleClose = () => {
    if (typeof onClose === 'function') onClose()
  }

  const handleCopyErrors = async () => {
    if (!errors.length) return

    const errorText = errors.join('\n')
    try {
      await navigator.clipboard.writeText(errorText)
      message.success('Copied all errors')
    } catch (error) {
      message.error('Unable to copy errors')
    }
  }

  return (
    <Modal
      title={`Validation Errors (${errorCount})`}
      visible={visible}
      onCancel={handleClose}
      width={750}
      footer={[
        <Button key='copy' onClick={handleCopyErrors} disabled={!errorCount}>
          Copy all errors
        </Button>,
        <Button key='close' type='primary' onClick={handleClose}>
          I&apos;ll Fix These Errors
        </Button>,
      ]}
    >
      <Alert
        type='error'
        showIcon
        message='Please fix the following errors before applying changes:'
        style={{ marginBottom: 12 }}
      />
      {warningMessage && (
        <Alert
          type='warning'
          showIcon
          message={warningMessage}
          style={{ marginBottom: 16 }}
        />
      )}
      <div style={{ maxHeight: 400, overflowY: 'auto' }}>
        <ul style={{ margin: 0, paddingLeft: 20 }}>
          {errors.map((error, index) => (
            <li
              key={`${error}-${index}`}
              style={{ marginBottom: 8, fontSize: 14 }}
            >
              {error}
            </li>
          ))}
        </ul>
      </div>
    </Modal>
  )
}

export default ValidationErrorsModal
